import { useState } from 'react';
import './Contacto.css';

const contactOptions = [
  { icon: '📱', label: 'WhatsApp', value: 'Escríbenos directo', action: 'https://wa.me/573229385277?text=Hola%2C%20me%20interesa%20conocer%20los%20servicios%20de%20KAIROS%20AI.' },
  { icon: '📧', label: 'Email', value: 'camilo@kairoslab.com.co', action: 'mailto:camilo@kairoslab.com.co' },
  { icon: '📍', label: 'Ubicación', value: 'Ibagué, Tolima · Colombia', action: null },
];

export default function Contacto() {
  const [form, setForm] = useState({ nombre: '', empresa: '', servicio: '', mensaje: '' });
  const [sent, setSent] = useState(false);

  const handleChange = e => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = () => {
    if (!form.nombre || !form.empresa || !form.mensaje) return;
    const msg = encodeURIComponent(
      `Hola KAIROS AI 👋\n\nNombre: ${form.nombre}\nEmpresa/Institución: ${form.empresa}\nServicio de interés: ${form.servicio || 'Por definir'}\n\nMensaje:\n${form.mensaje}`
    );
    window.open(`https://wa.me/573229385277?text=${msg}`, '_blank');
    setSent(true);
  };

  return (
    <main className="contacto-page">
      <section className="page-hero">
        <div className="page-hero__bg"><div className="page-hero__orb" /></div>
        <div className="container page-hero__content">
          <div className="tag">Contacto</div>
          <h1 className="page-hero__title">Hablemos de<br /><span>tu proyecto</span></h1>
          <p className="page-hero__sub">Agenda una sesión gratuita de 30 minutos. Sin compromiso, con resultados concretos.</p>
        </div>
      </section>

      <section className="section" style={{paddingTop: 0}}>
        <div className="container">
          <div className="contacto-grid">

            {/* FORMULARIO */}
            <div className="contacto-form-wrap">
              <h2>Cuéntanos sobre tu empresa</h2>
              <p>Completa el formulario y te contactamos en menos de 24 horas.</p>

              {sent ? (
                <div className="form-success">
                  <span>✅</span>
                  <h3>¡Mensaje enviado!</h3>
                  <p>Te contactaremos muy pronto. ¡Gracias por confiar en KAIROS AI!</p>
                  <button className="btn-primary" onClick={() => setSent(false)} style={{marginTop:16}}>Enviar otro mensaje</button>
                </div>
              ) : (
                <div className="contacto-form">
                  <div className="form-group">
                    <label>Nombre completo *</label>
                    <input name="nombre" value={form.nombre} onChange={handleChange} placeholder="Tu nombre" />
                  </div>
                  <div className="form-group">
                    <label>Empresa o institución *</label>
                    <input name="empresa" value={form.empresa} onChange={handleChange} placeholder="Nombre de tu empresa o entidad" />
                  </div>
                  <div className="form-group">
                    <label>Servicio de interés</label>
                    <select name="servicio" value={form.servicio} onChange={handleChange}>
                      <option value="">Seleccionar servicio...</option>
                      <option>Agentes IA para Ventas</option>
                      <option>Atención al Cliente IA</option>
                      <option>Análisis de Datos</option>
                      <option>Estrategia y Redes Sociales</option>
                      <option>Transformación Digital Sector Público</option>
                      <option>Consultoría en Adopción de IA</option>
                      <option>No sé, necesito orientación</option>
                    </select>
                  </div>
                  <div className="form-group">
                    <label>¿Qué necesitas? *</label>
                    <textarea name="mensaje" value={form.mensaje} onChange={handleChange} placeholder="Cuéntanos brevemente tu reto o necesidad..." rows={4} />
                  </div>
                  <button className="btn-primary form-submit" onClick={handleSubmit}>
                    Enviar por WhatsApp →
                  </button>
                  <p className="form-note">Al enviar, se abrirá WhatsApp con tu mensaje listo para enviarnos.</p>
                </div>
              )}
            </div>

            {/* CONTACTO DIRECTO */}
            <div className="contacto-info">
              <h3>Contacto directo</h3>
              <div className="contact-options">
                {contactOptions.map((c, i) => (
                  <div className="contact-option" key={i}>
                    <span className="contact-option__icon">{c.icon}</span>
                    <div>
                      <strong>{c.label}</strong>
                      {c.action ? (
                        <a href={c.action} target="_blank" rel="noreferrer">{c.value}</a>
                      ) : (
                        <span>{c.value}</span>
                      )}
                    </div>
                  </div>
                ))}
              </div>

              <div className="contacto-calendar">
                <div className="tag">Agenda rápida</div>
                <h4>Sesión de diagnóstico gratuita</h4>
                <p>30 minutos · Por videollamada · Sin costo</p>
                <ul>
                  <li>✦ Analizamos tus procesos actuales</li>
                  <li>✦ Identificamos oportunidades de automatización</li>
                  <li>✦ Te presentamos un plan inicial</li>
                </ul>
                <a
                  href="https://wa.me/573229385277?text=Hola%2C%20quiero%20agendar%20una%20sesi%C3%B3n%20de%20diagn%C3%B3stico%20gratuita%20con%20KAIROS%20AI."
                  target="_blank"
                  rel="noreferrer"
                  className="btn-primary"
                  style={{marginTop: 20, display: 'inline-flex'}}
                >
                  Agendar por WhatsApp →
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}
